import React from 'react';

export default function LoadingVehicle() {
    return (
        <article className="card card--loading">
            <div className="card__header" />
            <div className="card__content">
                <div className="card__text-group">
                    <div className="card__title" />
                    <div className="card__description" />
                </div>
                <div className="card__details">
                    <div className="card__detail-pill" />
                    <div className="card__detail-pill" />
                    <div className="card__detail-pill" />
                </div>
                <div className="card__price-row">
                    <div className="card__price" />
                </div>
            </div>
        </article>
    );
}
